import { LookupOfSystemInt32 } from '../../generated/auth/models/Sasfin/Wealth/Online/BL/Models/lookup-of-system-int-32';

export interface IPortfoliosState {
  portfoliosByType: LookupOfSystemInt32[];
  allPortfolios: LookupOfSystemInt32[];
  isLoadingByType: boolean;
  isLoadingAll: boolean;
}

export const initialUIState: IPortfoliosState = {
  portfoliosByType: [],
  allPortfolios: [],
  isLoadingByType: false,
  isLoadingAll: false,
};
